<template>
  <transition
    name="router-anim"
    enter-active-class="animated fadeInDown"
    leave-active-class="animated fadeOutLeft"
  >
    <div class="bevezeto">
      <h1>Az emberek nem céget, hanem vezetőt választanak</h1>
      <div class="introcont">
        <simplebar data-simplebar-auto-hide="false">
          <div class="strong">
            - és ahogy az élet sok területén hozott újfajta kihívásokat a század, úgy igaz ez a vezetőkre is. Teljesen máshogy kommunikálunk egymással mint akárcsak 5 évvel ezelőtt, a technológiai környezet folyamatos fejlődésével átalakult kapcsolatunk a munkával. Másmilyen vezetőkre vágyunk – vajon készen állsz erre a kihívásra?
          </div>
          <div class="details">
            <span class="capital">Mit mérünk és hogyan?</span>
            Három szempont alapján mérjük, hogy mennyire vagy XXI. századi vezető: networking, üzletorientáltság, coach szemléletű vezetés. A három blokkra bontott tesztkérdések előtt elmondjuk, mit rejtenek ezek a fogalmak.
          </div>
          <div class="details2">
            A következő tesztben, amelynek összeállításában coach, vezetőfejlesztő és pszichológus is részt vett, a kérdésekre egy 1-5 ig tartó skálán kell válaszolnod. Az egyes értékelés azt jelenti, hogy egyáltalán nem jellemző rád, az ötös pedig, hogy mindig így teszel. A teszt kitöltése alapján három féle értékelést adunk.
          </div>
          <div class="details2">
            Fontos, hogy a teszt akkor leghasznosabb, nem a vágyaid, hanem a tények és a visszajelzések alapján töltöd ki. Kezdjünk is bele!
          </div>
        </simplebar>
      </div>
      <div class="buttons">
        <router-link
          to="/kviz"
          tag="button"
          class="btn"
        >Kezdjük</router-link>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.bevezeto {
  position: relative;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto auto auto;
  width: calc(100vw - 500px);
  z-index: 0;
}
h1 {
  font-size: 30px;
  margin: 60px 0 15px 0;
  grid-column: 1/2;
  grid-row: 1/2;
}
.introcont {
  height: 220px;
  grid-column: 1/2;
  grid-row: 2/3;
}
.strong {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 20px;
}
.details,
.details2 {
  font-size: 18px;
}
.details2 {
  margin-top: 7px;
}
.capital {
  text-transform: uppercase;
  display: block;
}
.buttons {
  margin-top: 20px;
  justify-self: center;
  grid-column: 1/2;
  grid-row: 3/4;
}
@media screen and (max-width: 1100px) {
  .bevezeto {
    width: calc(100vw - 300px);
  }
}
@media screen and (max-width: 767px) {
  .bevezeto {
    width: calc(100vw - 60px);
  }
  h1 {
    margin: 20px 0 15px 0;
    font-size: 24px;
  }
}
</style>
<style>
.bevezeto .simplebar-scrollbar:before {
  background: #42475c;
}
.simplebar-content {
  padding-right: 30px !important;
}
.bevezeto .simplebar-scrollbar:before {
  opacity: 0.5;
}
</style>

<script>
// @ is an alias to /src
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'

export default {
  name: 'bevezeto',
  components: {
    simplebar
  },
  data: function () {
    return {
    }
  },
  methods: {
    initBGmove () {
      this.$store.state.bgCurrent = 1
      const WindowWidth = document.querySelector('body').clientWidth
      const bgIMG = document.querySelector('.backgroundimg')
      const stepSize = (bgIMG.scrollWidth - WindowWidth) / this.$store.state.bgMax
      bgIMG.setAttribute('style', 'transform: translateX(' + (stepSize * this.$store.state.bgCurrent) * -1 + 'px)')
    }
  },
  mounted () {
    this.initBGmove()
  }
}
</script>
